import { BooleanSelectProps } from 'src/compositions/Profile/formComponents'
import { MasterData } from 'src/models/MasterData'

const getYears = (
  from: number,
  option: {
    offset?: number
  } = {},
) => {
  const { offset = 0 } = option
  const year = new Date().getFullYear()
  const allYears: MasterData[] = []
  // eslint-disable-next-line no-plusplus
  for (let x = offset; x <= year - from; x++)
    allYears.push({ label: `${year - x}`, value: `${year - x}` })

  return allYears
}
export const getBirthYears = () => getYears(1900, { offset: 15 })

export const getFoundedYears = () => getYears(1800)

export const LISTED_OPTIONS: BooleanSelectProps['options'] = [
  { value: 'true', label: '上場' },
  { value: 'false', label: '未上場' },
]

export const AVAILABLITIES_OPTIONS: BooleanSelectProps['options'] = [
  { value: 'true', label: '可能' },
  { value: 'false', label: '不可能' },
]

export const maxUploadFileSizeByte = 31457280 // 30MB
export const maxUploadFileSizeMB = 30 // 30MB
